import PropTypes from 'prop-types'
import { memo, useMemo, useRef } from 'react'
import SplitTextBasic from 'components/util/SplitText/SplitTextBasic'
import usePressEvents from 'lib/react/hooks/usePressEvents'
import conditionalProperties from 'lib/util/conditionalProperties'
import styles from './Item.module.scss'

/**
 * The `Item`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Item (props) {
  const { Tag, children, className, isActive, ...rest } = props
  const ref = useRef()
  const isPressing = usePressEvents(ref)
  const attributes = useMemo(
    () => ({
      className: `${styles.item} ${className}`.trimEnd(),
      ...conditionalProperties([
        [isActive, { 'data-a': '' }],
        [isPressing, { 'data-p': '' }]
      ])
    }),
    [className, isActive, isPressing]
  )

  return (
    <li className={styles.itemWrapper}>
      <Tag ref={ref} {...attributes} {...rest}>
        <span>
          <SplitTextBasic content={children} />
        </span>
      </Tag>
    </li>
  )
}

/** @type {object} */
Item.propTypes = {
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string,
  isActive: PropTypes.bool
}

/** @type {object} */
Item.defaultProps = {
  children: null,
  Tag: 'a',
  className: '',
  isActive: false
}

// Memoize
export default memo(Item)
